
import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  INVALIDATE_STREAM, INVALIDATE_GROUP, UPLOAD_ASSET_REQUEST
} from 'constants/actionTypes.jsx';

import { call, put, takeEvery, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import _ from 'lodash';
import buildUrl from 'build-url';

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const paperfliteApiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;

const STREAMS_BASE_URL = `${paperfliteApiUrl}/api/2.0/streams`;
const STREAMS_BASE_URL_NEW = `${paperfliteApiUrl}/api/2.2/streams`;
const HUB_STREAMS_URL = `${STREAMS_BASE_URL}/hub`;
const GROUP_BASE_URL = `${paperfliteApiUrl}/api/2.0/groups`;
/*
* Fetch hub streams
*/
export const fetchHubStreamsRequest = createAction(FETCHING_HUB_STREAMS_REQUEST);

export const fetchingHubStreamsSucceeded = createAction(FETCHING_HUB_STREAMS_SUCCEEDED, (response) => {
  return {
    response: response
  }
})

const fetchingHubStreamsFailed = createAction(FETCHING_HUB_STREAMS_FAILED, (error) => {
  return {
    error: error,
  }
})

function* fetchHubStreams() {

  const fetchingHubStreamsAPI = () => {
    return axios.get(HUB_STREAMS_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchingHubStreamsAPI);
    if (response) {
      yield put(fetchingHubStreamsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingHubStreamsFailed(error));
  }
}


/*
* Fetch stream
*/
export const fetchStreamRequest = createAction(FETCHING_STREAM_REQUEST, (request, page) => {
  return {
        request: request,
        page: page,
       }
})

export const fetchingStreamSucceeded = createAction(FETCHING_STREAM_SUCCEEDED, (response, id) => {
  return {
    response: response,
    id: id
  }
})

export const fetchingStreamFailed = createAction(FETCHING_STREAM_FAILED, (error, id) => {
  return {
    error: error,
    id: id
  }
})


function* fetchStream(action) {
  const { id, limit, sort, type, callback } = action.payload.request;
  const page = action.payload.page

  let url = buildUrl(STREAMS_BASE_URL_NEW, {
    path: `/${id}/children?page=${page}&limit=${limit}&sort=${sort}&type=${type}`,
  });

  const fetchingStreamAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStreamAPI);

    if (response) {
      yield put(fetchingStreamSucceeded(response, id));
    }
  } catch (error) {
    yield put(fetchingStreamFailed(error, id));
  }
}

/*
* Fetch group
*/
export const fetchGroupRequest = createAction(FETCHING_GROUP_REQUEST, (id)=> {
  return {
    id: id
  }
})

export const fetchingGroupSucceeded = createAction(FETCHING_GROUP_SUCCEEDED, (response, id)=> {
  return {
    response: response,
    id: id
  }
})

export const fetchingGroupFailed = createAction(FETCHING_GROUP_FAILED, (error, id)=> {
  return {
    error: error,
    id: id
  }
})

function* fetchGroup(action) {
  const {id, callback} = action.payload;

  let url = buildUrl(GROUP_BASE_URL, {
    path: `/${id}`
  });

  const fetchingGroupsAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingGroupsAPI);

    if(response) {
      yield put(fetchingGroupSucceeded(response, id));
    }
  } catch (error) {
    yield put(fetchingGroupFailed(error, id));
  }
}

export const uploadStreamAsset = createAction(UPLOAD_ASSET_REQUEST, (asset)=>{
  return {
    asset: asset
  }
})

export const invalidateStream = createAction(INVALIDATE_STREAM);

export const invalidateGroup = createAction(INVALIDATE_GROUP);


export default function* paperfliteSaga() {
  yield takeLatest(FETCHING_HUB_STREAMS_REQUEST, fetchHubStreams);
  yield takeEvery(FETCHING_STREAM_REQUEST, fetchStream);
  yield takeEvery(UPLOAD_ASSET_REQUEST, uploadStreamAsset);
  yield takeEvery(FETCHING_GROUP_REQUEST, fetchGroup);
};
